import axios from 'axios';
import URLS from '../../util/urls.js'

const state = {
  recibosRetorno: [],
  historicoRetornos: []
}

const mutations = {
  atualizarRecibosRetorno(state, payload) {
    state.recibosRetorno = payload;
  },

  atualizarHistoricoRetornos(state, payload) {
    state.historicoRetornos = payload;
  },

  limparRecibosRetorno(state) {
    state.recibosRetorno = []
  }
}

const actions = {
  limparRecibosRetorno(context) {
    context.commit('limparRecibosRetorno');
  },

  processarRetorno(context, payload) {
    return axios.post(URLS.ARQUIVO_RETORNO_PROCESSAR, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarRecibosRetorno', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('processarRetorno', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarHistoricoRetorno(context, payload) {
    return axios.post(URLS.ARQUIVO_RETORNO_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarHistoricoRetornos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarHistoricoRetorno', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}